import { Map, List } from 'immutable'
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
@Component({
  selector: 'property-invoice',
  templateUrl: './property-invoice.component.html',
  styleUrls: ['./property-invoice.component.css'],
})
export class PropertyInvoiceComponent implements OnInit {
  @Input() public data: Map<string, any>
  @Input() public activeForm: Map<string, any>
  @Input() public isLoading: boolean
  @Input() public propertyDetails: Map<string, any>
  @Output() public onReport: EventEmitter<any> = new EventEmitter()
  @Input() public isPropertyReportGenerating: boolean
  @Input() public dynamicFieldsTranslation: any

  constructor() {}

  ngOnInit() {}
}
